import { render, staticRenderFns } from "./myQuestionCourse.vue?vue&type=template&id=7294afef&scoped=true"
import script from "./myQuestionCourse.vue?vue&type=script&lang=js"
export * from "./myQuestionCourse.vue?vue&type=script&lang=js"
import style0 from "./myQuestionCourse.vue?vue&type=style&index=0&id=7294afef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294afef",
  null
  
)

export default component.exports